module.exports = __webpack_public_path__ + "img/chart2-s.66c10152.png";